<template>
  <el-dialog
    center
    width="600px"
    :title="(isEdit ? '编辑' : '新增') + '系统功能'"
    :visible.sync="dialogFormVisible"
    @close="resetForm"
  >
    <el-form :model="editForm" :rules="editRules" ref="editForm">
      <el-form-item label="功能名称" :label-width="formLabelWidth" prop="name">
        <el-input
          v-model="editForm.name"
          auto-complete="off"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="功能编码"
        :label-width="formLabelWidth"
        prop="operationCode"
      >
        <el-input
          v-model="editForm.operationCode"
          auto-complete="off"
          placeholder="请输入功能编码"
        ></el-input>
      </el-form-item>
      <el-form-item label="操作描述" :label-width="formLabelWidth">
        <el-input
          v-model="editForm.operationDesc"
          auto-complete="off"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="页面路径" :label-width="formLabelWidth" prop="path">
        <el-input
          v-model="editForm.path"
          auto-complete="off"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button
        @click="
          dialogFormVisible = false;
          resetForm();
        "
        >取 消</el-button
      >
      <el-button type="primary" @click="submitEdit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
//import { houseList } from '@/api/houseApi.js';
import { addFunctionApi, updateFunctionApi } from '@/api/user.js';
export default {
  name: 'AlarmRuleForm',
  props: ['list'],
  data() {
    return {
      dialogFormVisible: false,
      editForm: {
        operationCode: '',
        name: '',
        operationDesc: '',
      },
      isEdit: false,
      editRules: {
        name: [
          { required: true, message: '功能名称不能为空', trigger: 'blur' },
        ],
        operationCode: [
          { required: true, message: '功能编码不能为空', trigger: 'blur' },
        ],
        path: [
          { required: true, message: '页面路径不能为空', trigger: 'blur' },
        ],
      },
      formLabelWidth: '120px',
    };
  },

  methods: {
    resetForm() {
      this.editForm = {};
      this.$refs.editForm.resetFields();
    },
    async submitEdit() {
      this.$refs.editForm.validate(async (valid) => {
        if (!valid) return this.$message.error('格式不对哦  ，检查一下呗!');
        if (this.isEdit) {
          this.editSubmit();
        } else {
          this.addSubmit();
        }
      });
    },
    async editSubmit() {
      const data = { ...this.editForm };
      try {
        let res = await updateFunctionApi(data);
        if (res.code !== 200) return;
        this.$message.success('编辑成功');
        this.dialogFormVisible = false;
        this.$refs.editForm.resetFields();
        this.$parent.fetchData();
      } catch (error) {
        window.console.log(error);
      }
    },
    async addSubmit() {
      const data = { ...this.editForm };
      // const data = `operationCode=${this.editForm.operationCode}&name=${this.editForm.name}&operationDesc=${this.editForm.operationDesc}&path=${this.editForm.path}`;
      try {
        let res = await addFunctionApi(data);
        if (res.code !== 200) return;
        this.$message.success('新增成功');
        this.dialogFormVisible = false;
        this.$refs.editForm.resetFields();
        this.$parent.fetchData();
      } catch (error) {
        window.console.log(error);
      }
    },
  },
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  min-height: 70px;
  line-height: 70px;
  text-align: center;
}
.avatar {
  width: 100px;
  display: block;
}
</style>
